/* @flow */

import React, { Component } from 'react';
import * as Api from './api';
import { Segment } from 'semantic-ui-react';
import BlockListRender from './components/BlockListRender';

type Props = {
  blocks: Array<EditorialBlock>,
};

type State = {
  isFetching: boolean,
  templates: Array<EditorialBlockTemplate>,
};

class Render extends Component {
  props: Props;
  state: State;

  constructor(props: Props) {
    super(props);

    this.state = {
      isFetching: false,
      templates: [],
    };
  }

  componentDidMount() {
    this.setState({
      isFetching: true,
    });

    Api.fetchTemplates().then(templates =>
      this.setState({
        isFetching: false,
        templates,
      })
    );
  }

  render() {
    const { blocks } = this.props;
    const { isFetching, templates } = this.state;

    if (isFetching) {
      return <Segment loading style={{ minHeight: '180px' }} />;
    }

    return (
      <div>
        <BlockListRender blocks={blocks} templates={templates} />
      </div>
    );
  }
}

export default Render;



// WEBPACK FOOTER //
// ./src/modules/edito/Render.js